module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "notificationHistory": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.notificationHistoryLoaded == false) ? _c('h2', {
    staticStyle: {
      "padding-top": "10%"
    }
  }, [_c('center', [_vm._v("Loading History"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])], 1) : _vm._e()]), _vm._v(" "), (_vm.notificationHistoryLoaded == true) ? _c('v-data-table', {
    attrs: {
      "search": _vm.search,
      "headers": _vm.headers,
      "items": _vm.notificationHistory,
      "expand": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckType(props.item.type)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.entity))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.entity_subject))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "40%"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.fncSetAttachments(props.item.filename))
          }
        }), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckBool(props.item.sent)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(_vm.fncCheckdate(props.item.send_date)))])])]
      }
    }], null, false, 896859168)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}